/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ChargerMeterValue } from "./ChargerMeterValue";
import {
    ChargerMeterValueFromJSON,
    ChargerMeterValueFromJSONTyped,
    ChargerMeterValueToJSON,
} from "./ChargerMeterValue";

/**
 *
 * @export
 * @interface Transaction
 */
export interface Transaction {
    /**
     *
     * @type {number}
     * @memberof Transaction
     */
    transactionId?: number;
    /**
     *
     * @type {string}
     * @memberof Transaction
     */
    transactionLocalId?: string;
    /**
     *
     * @type {string}
     * @memberof Transaction
     */
    deviceIdentity?: string;
    /**
     *
     * @type {string}
     * @memberof Transaction
     */
    deviceType?: TransactionDeviceTypeEnum;
    /**
     *
     * @type {number}
     * @memberof Transaction
     */
    connectorIndex?: number;
    /**
     *
     * @type {string}
     * @memberof Transaction
     */
    connectorIdentity?: string;
    /**
     *
     * @type {string}
     * @memberof Transaction
     */
    passthroughDeviceIdentity?: string;
    /**
     *
     * @type {string}
     * @memberof Transaction
     */
    managedBy?: string;
    /**
     *
     * @type {string}
     * @memberof Transaction
     */
    centralSystemTransactionId?: string;
    /**
     *
     * @type {number}
     * @memberof Transaction
     */
    meterStart?: number;
    /**
     *
     * @type {number}
     * @memberof Transaction
     */
    meterStop?: number;
    /**
     *
     * @type {number}
     * @memberof Transaction
     */
    soCStart?: number;
    /**
     *
     * @type {number}
     * @memberof Transaction
     */
    soCEnd?: number;
    /**
     *
     * @type {string}
     * @memberof Transaction
     */
    idTagStart?: string;
    /**
     *
     * @type {string}
     * @memberof Transaction
     */
    idTagStop?: string;
    /**
     *
     * @type {number}
     * @memberof Transaction
     */
    reservationId?: number;
    /**
     *
     * @type {string}
     * @memberof Transaction
     */
    odometer?: string;
    /**
     *
     * @type {number}
     * @memberof Transaction
     */
    vehicleId?: number;
    /**
     *
     * @type {string}
     * @memberof Transaction
     */
    vehicleRegistrationPlate?: string;
    /**
     *
     * @type {Date}
     * @memberof Transaction
     */
    start?: Date;
    /**
     *
     * @type {Date}
     * @memberof Transaction
     */
    end?: Date;
    /**
     *
     * @type {string}
     * @memberof Transaction
     */
    stopTransactionReason?: string;
    /**
     *
     * @type {Date}
     * @memberof Transaction
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof Transaction
     */
    updatedAt?: Date;
    /**
     *
     * @type {number}
     * @memberof Transaction
     */
    totalCost?: number;
    /**
     *
     * @type {string}
     * @memberof Transaction
     */
    currencyCode?: string;
    /**
     *
     * @type {string}
     * @memberof Transaction
     */
    billingStatus?: TransactionBillingStatusEnum;
    /**
     *
     * @type {Array<ChargerMeterValue>}
     * @memberof Transaction
     */
    chargerMeterValues?: Array<ChargerMeterValue>;
}

/**
 * @export
 */
export const TransactionDeviceTypeEnum = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;
export type TransactionDeviceTypeEnum =
    (typeof TransactionDeviceTypeEnum)[keyof typeof TransactionDeviceTypeEnum];

/**
 * @export
 */
export const TransactionBillingStatusEnum = {
    Unknown: "Unknown",
    NotRequired: "NotRequired",
    Pending: "Pending",
    Raised: "Raised",
    Paid: "Paid",
    Failed: "Failed",
} as const;
export type TransactionBillingStatusEnum =
    (typeof TransactionBillingStatusEnum)[keyof typeof TransactionBillingStatusEnum];

/**
 * Check if a given object implements the Transaction interface.
 */
export function instanceOfTransaction(value: object): value is Transaction {
    return true;
}

export function TransactionFromJSON(json: any): Transaction {
    return TransactionFromJSONTyped(json, false);
}

export function TransactionFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): Transaction {
    if (json == null) {
        return json;
    }
    return {
        transactionId:
            json["transactionId"] == null ? undefined : json["transactionId"],
        transactionLocalId:
            json["transactionLocalId"] == null
                ? undefined
                : json["transactionLocalId"],
        deviceIdentity:
            json["deviceIdentity"] == null ? undefined : json["deviceIdentity"],
        deviceType: json["deviceType"] == null ? undefined : json["deviceType"],
        connectorIndex:
            json["connectorIndex"] == null ? undefined : json["connectorIndex"],
        connectorIdentity:
            json["connectorIdentity"] == null
                ? undefined
                : json["connectorIdentity"],
        passthroughDeviceIdentity:
            json["passthroughDeviceIdentity"] == null
                ? undefined
                : json["passthroughDeviceIdentity"],
        managedBy: json["managedBy"] == null ? undefined : json["managedBy"],
        centralSystemTransactionId:
            json["centralSystemTransactionId"] == null
                ? undefined
                : json["centralSystemTransactionId"],
        meterStart: json["meterStart"] == null ? undefined : json["meterStart"],
        meterStop: json["meterStop"] == null ? undefined : json["meterStop"],
        soCStart: json["soCStart"] == null ? undefined : json["soCStart"],
        soCEnd: json["soCEnd"] == null ? undefined : json["soCEnd"],
        idTagStart: json["idTagStart"] == null ? undefined : json["idTagStart"],
        idTagStop: json["idTagStop"] == null ? undefined : json["idTagStop"],
        reservationId:
            json["reservationId"] == null ? undefined : json["reservationId"],
        odometer: json["odometer"] == null ? undefined : json["odometer"],
        vehicleId: json["vehicleId"] == null ? undefined : json["vehicleId"],
        vehicleRegistrationPlate:
            json["vehicleRegistrationPlate"] == null
                ? undefined
                : json["vehicleRegistrationPlate"],
        start: json["start"] == null ? undefined : new Date(json["start"]),
        end: json["end"] == null ? undefined : new Date(json["end"]),
        stopTransactionReason:
            json["stopTransactionReason"] == null
                ? undefined
                : json["stopTransactionReason"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
        totalCost: json["totalCost"] == null ? undefined : json["totalCost"],
        currencyCode:
            json["currencyCode"] == null ? undefined : json["currencyCode"],
        billingStatus:
            json["billingStatus"] == null ? undefined : json["billingStatus"],
        chargerMeterValues:
            json["chargerMeterValues"] == null
                ? undefined
                : (json["chargerMeterValues"] as Array<any>).map(
                      ChargerMeterValueFromJSON,
                  ),
    };
}

export function TransactionToJSON(value?: Transaction | null): any {
    if (value == null) {
        return value;
    }
    return {
        transactionId: value["transactionId"],
        transactionLocalId: value["transactionLocalId"],
        deviceIdentity: value["deviceIdentity"],
        deviceType: value["deviceType"],
        connectorIndex: value["connectorIndex"],
        connectorIdentity: value["connectorIdentity"],
        passthroughDeviceIdentity: value["passthroughDeviceIdentity"],
        managedBy: value["managedBy"],
        centralSystemTransactionId: value["centralSystemTransactionId"],
        meterStart: value["meterStart"],
        meterStop: value["meterStop"],
        soCStart: value["soCStart"],
        soCEnd: value["soCEnd"],
        idTagStart: value["idTagStart"],
        idTagStop: value["idTagStop"],
        reservationId: value["reservationId"],
        odometer: value["odometer"],
        vehicleId: value["vehicleId"],
        vehicleRegistrationPlate: value["vehicleRegistrationPlate"],
        start:
            value["start"] == null ? undefined : value["start"].toISOString(),
        end: value["end"] == null ? undefined : value["end"].toISOString(),
        stopTransactionReason: value["stopTransactionReason"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
        totalCost: value["totalCost"],
        currencyCode: value["currencyCode"],
        billingStatus: value["billingStatus"],
        chargerMeterValues:
            value["chargerMeterValues"] == null
                ? undefined
                : (value["chargerMeterValues"] as Array<any>).map(
                      ChargerMeterValueToJSON,
                  ),
    };
}
